// Small round agent avatar: photo when available, initials fallback otherwise.
// Used in the admin agents lists, site-agents tab, etc.

import type { CSSProperties } from 'react';
import { resolveAvatarUrl } from '../lib/server-origin';
import styles from './Avatar.module.css';

function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toUpperCase() || '?';
}

export function Avatar({
  name,
  avatarUrl,
  size = 28,
}: {
  name: string;
  avatarUrl?: string | null;
  size?: number;
}) {
  const box: CSSProperties = { width: size, height: size };
  if (avatarUrl) {
    return (
      <img
        className={styles.img}
        style={box}
        src={resolveAvatarUrl(avatarUrl) ?? undefined}
        alt=""
        aria-hidden
      />
    );
  }
  return (
    <span
      className={styles.fallback}
      style={{ ...box, fontSize: Math.round(size * 0.36) }}
      aria-hidden
    >
      {initialsOf(name)}
    </span>
  );
}
